<template>
  <v-container fluid style="height: 100%; padding: 0;">
    <v-layout fill-height row wrap style="height: 100%">
      <AdminSideBarMenu />
      <v-flex class="dashboard-view">
        <div v-if="isSelectedTab('activity')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Requests</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Activity</v-breadcrumbs-item>
          </v-breadcrumbs>
          <activity />
        </div>
        <div v-if="isSelectedTab('events')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Requests</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Events</v-breadcrumbs-item>
          </v-breadcrumbs>
          <events />
        </div>
        <div v-if="isSelectedTab('companies')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Requests</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Companies</v-breadcrumbs-item>
          </v-breadcrumbs>
          <company />
        </div>
        <!-- <div v-if="isSelectedTab('groups')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Requests</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Group Posts</v-breadcrumbs-item>
          </v-breadcrumbs>
          <group-posts />
        </div>
        <div v-if="isSelectedTab('group-events')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Requests</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Group Events</v-breadcrumbs-item>
          </v-breadcrumbs>
          <group-events />
        </div> -->
        <PageFooter />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Activity from './Request/activity.vue'
  import GroupPosts from './Request/groupposts.vue'
  import GroupEvents from './Request/groupevents.vue'
  import Events from './Request/events.vue'
  import Company from './Request/company.vue'
  import MainMenu from '../../../components/main-menu/MainMenuComponent.vue'
  import UserToolbar from '../../../components/Toolbar.vue'
  import AdminSideBarMenu from './Components/AdminSideBar.vue'
  import PageFooter from './Components/PageFooter.vue'

  export default {
    components: {
      Activity,
      GroupPosts,
      Events,
      Company,
      MainMenu,
      AdminSideBarMenu,
      UserToolbar,
      GroupEvents,
      PageFooter
    },
    mounted () {
      const payload = {
        meta: {
          'h1': 'Requests',
          'title': 'Requests',
          'description': 'Admin Settings',
          'keywords': '',
          'requiresAuth': true
        }
      }
      document.title = payload.meta.title
      this.$store.commit('setHeaderInfo', payload)
    },
    computed: {
      styles () {
        return this.$store.getters.getStyles
      }
    },
    data: () => ({
      drawer: true,
      h1: window.title
    }),
    methods: {
      onDismiss () {
        this.$store.dispatch('setError', null)
        this.$store.dispatch('setProcess', 'null')
      },
      triggerDrawer () {
        this.drawer = !this.drawer
      },
      isSelectedTab (tabName) {
        const urlSection = this.$route.params.id || 'activity'
        return tabName === urlSection
      }
    }
  }
</script>

<style lang="scss" scoped>
  .my_white ul li a{
    color:white !important;
  }
</style>



// WEBPACK FOOTER //
// RequestView.vue?2d80506c